module.exports = "https://cdn.hellotech.com/client-assets/yale_locks_mobile_4f4a691bc189e65873a3417f074dd8c5.webp";